angular.module("vgresiduos").controller("PendingDestinationPopupButtonCtrl", [
	function () {
		"use strict";
	}
]);
